<TextInputStyleProvider><BaseInput v-bind="$attrs" v-model="date" :label="label" :type="InputElementTypes.Date"></BaseInput></TextInputStyleProvider>